var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#1d3f72",
    height: 20,
    width: 20,
    y: 19,
    x: 19
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#5699d2;#1d3f72;#1d3f72",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#1d3f72",
    height: 20,
    width: 20,
    y: 19,
    x: 40
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.125s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#5699d2;#1d3f72;#1d3f72",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#1d3f72",
    height: 20,
    width: 20,
    y: 19,
    x: 61
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.25s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#5699d2;#1d3f72;#1d3f72",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#1d3f72",
    height: 20,
    width: 20,
    y: 40,
    x: 19
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.875s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#5699d2;#1d3f72;#1d3f72",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#1d3f72",
    height: 20,
    width: 20,
    y: 40,
    x: 61
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.375s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#5699d2;#1d3f72;#1d3f72",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#1d3f72",
    height: 20,
    width: 20,
    y: 61,
    x: 19
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.75s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#5699d2;#1d3f72;#1d3f72",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#1d3f72",
    height: 20,
    width: 20,
    y: 61,
    x: 40
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.625s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#5699d2;#1d3f72;#1d3f72",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#1d3f72",
    height: 20,
    width: 20,
    y: 61,
    x: 61
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.5s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#5699d2;#1d3f72;#1d3f72",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.803789be955119da093c90fd6994d204.svg";
export { ForwardRef as ReactComponent };